export default __webpack_public_path__ + "static/logo_reactnative-e5bc0808b02a9e6d97bb822defce6580.png";